import { render, staticRenderFns } from "./GroupOptimizationHistoryItem.vue?vue&type=template&id=bc54d470&scoped=true"
import script from "./GroupOptimizationHistoryItem.vue?vue&type=script&lang=js"
export * from "./GroupOptimizationHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./GroupOptimizationHistoryItem.vue?vue&type=style&index=0&id=bc54d470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc54d470",
  null
  
)

export default component.exports